import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Checkbox from '@/components/atoms/Checkbox';
import { ToastError } from '@/components/molecules/ToastTemplate/ToastTemplate';
import type { OverviewCage } from '@/domain/client';

export interface LocationOverviewHistoricalCellProps {
    cage: OverviewCage;
    markHistorical: (cageId: number, historical: boolean) => Promise<unknown>;
}

export default function LocationOverviewHistoricalCell(props: LocationOverviewHistoricalCellProps) {
    const { cage, markHistorical } = props;
    const [isSetting, setIsSetting] = useState(false);
    const { t } = useTranslation();

    const updateHistorical = async () => {
        try {
            setIsSetting(true);
            await markHistorical(cage.cageId, cage.historicalSince == null);
        } catch {
            ToastError(
                t('organisms.locationOverviewTable.markHistoricalFailed'),
                'mark-historical-error'
            );
        } finally {
            setIsSetting(false);
        }
    };

    return (
        <Checkbox
            disabled={isSetting}
            checked={cage.historicalSince != null}
            onCheckedChange={updateHistorical}
        />
    );
}
